
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Snackbar, Alert } from "@mui/material";
import { hideToast } from "./toastActions";

const ToastMessageRedux = () => {
  const dispatch = useDispatch();
  const toast = useSelector((state) => state.toast);

  const handleClose = () => {
    dispatch(hideToast());
  };

  return (
    <Snackbar
      open={toast.open}
      autoHideDuration={4000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <Alert onClose={handleClose} severity={toast.severity} variant="filled">
        {toast.message}
      </Alert>
    </Snackbar>
  );
};

export default ToastMessageRedux;
